import { TCredentialsAction, CredentialsActionTypes } from './credentialsActions';
import { ICredentialsState } from './credentialsContext';

export const credentialsReducer = (state: ICredentialsState, action: TCredentialsAction): ICredentialsState => {
	switch (action.type) {
		case CredentialsActionTypes.SET_CREDENTIALS:
			return {
				...state,
				credentials: action.payload.credentials,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CredentialsActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case CredentialsActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case CredentialsActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case CredentialsActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case CredentialsActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
			};
		case CredentialsActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				currentPage: 1,
			};
		case CredentialsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CredentialsActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case CredentialsActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
